import React__default from 'react';
import clsx from 'clsx';
import './../../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../../util/Visible/Visible.js';
import { OutlineButton } from '../../../buttons/index.js';

const BrowseButton = ({ title, isDropzoneCondensed, disabled, onClick, classes = {} }) => (React__default.createElement(React__default.Fragment, null,
    React__default.createElement(Visible, { when: isDropzoneCondensed },
        React__default.createElement("div", { "data-testid": 'dropzone-button-condensed', onClick: onClick, className: clsx('c-dropzone__button--condensed', classes.title) }, title)),
    React__default.createElement(Visible, { when: !isDropzoneCondensed },
        React__default.createElement(OutlineButton, { "data-testid": 'dropzone-button', disabled: disabled, onClick: onClick, className: classes.button }, title))));

export { BrowseButton as default };
//# sourceMappingURL=BrowseButton.js.map
